import React, { useEffect, useRef, useState } from "react"
import { Container, Row, Col, Modal, Button, Form, Breadcrumb, Table, Tabs, Tab } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner/index'
import { ToastContainer, toast } from 'react-toastify';
import config from "../../config/config";
import axios from "axios";
import SuccessModal from "./SuccessModal";

const ArchiveModal = (props) => {
  const { archiveShow, setArchiveShow, noteUserId, setReloadData,  archiveMultiple , setArchieveMultiple , selectedRows , setSelectedRows} = props;
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState('');
  const [show, setShow] = useState(false);
  const selectedIdMultiple = selectedRows?.map((data)=>data.id)

  const handleCloseModal = () => {
    if(archiveShow){
      setArchiveShow(false);
    }
    else{
      setArchieveMultiple(false);
      setSelectedRows([]);
    }
  }

  useEffect(() => {
  }, [archiveShow])

  const archiveStudentData = async () => {
    setIsLoading(true)
    let path = config.siteUrl;
    var token = localStorage.getItem('access_token');

    const formData = new FormData();
    formData.append("LD_SID", noteUserId)
    formData.append("reason", reason)
    const res = await axios.post(path + '/classes/archive-raw-data', formData, {
      headers: {
        'Content-Type': 'Application/json',
        'Accept': 'Application/json',
        'Authorization': ` ${token}`
      }
    })
    // const res = response.data;
    if (res.data.status === 200) {
      setIsLoading(false)
      setShow(true)
      // setTimeout(() =>
      //   setArchiveShow(false)
      //   , 2000)
      // toast.success(res?.data?.message)
    } else {
      console.log(res)
      toast.error('Please enter reason to archive.')
      setIsLoading(false)
    }
  }

  const archiveStudentDataMultiple = async () => {
    setIsLoading(true);
    let path = config.siteUrl;
    var token = localStorage.getItem('access_token');

    const requestData = {
      student_ids: selectedIdMultiple, 
      reason: reason
    };

    try {
        const res = await axios.post(path + '/classes/multiple-archive-raw-data', requestData, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}` 
          }
        });

        if (res.data.status === 200) {
          setIsLoading(false);
          setShow(true);
        } else {
          toast.error('Please enter a reason to archive.');
          setIsLoading(false);
        }
    } catch (error) {
        toast.error('Something went wrong. Please try again.');
        setIsLoading(false);
    }
  };


  const onCloseRoll = () => {
    if(archiveShow){
      setArchiveShow(false);
      setReloadData(true)
    }
    else{
      setArchieveMultiple(false);
      setReloadData(true)
    }
  }

  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={archiveShow || archiveMultiple} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Action</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <div className="alert-modal-box mt-2">
                  {/* <p>Data <strong>BELOW</strong> will be modified for processing only, and <strong>NOT SAVED.</strong></p> */}
                  <p>Are you sure you want to archive this student(s)? Please provide a reason for this action </p>
                </div>
              </Row>

              <Form.Group className="mb-3 basic-form">
                <textarea id="w3review" name="w3review" rows="3" cols="50" placeholder="Please provide a reason to proceed..."
                  style={{ padding: '10px' }}
                  onChange={(e) => setReason(e.target.value)}
                  value={reason} />
                {/* <Form.Label>{dataRow.FIRSTNAME + ' ' + dataRow.LASTNAME}</Form.Label> */}
              </Form.Group>
            </div>


          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={() => {
              archiveShow ? archiveStudentData() : archiveStudentDataMultiple()
            }}>
              Archive
            </Button>
          </Modal.Footer>
        </Modal>
        {show == true ?
          <SuccessModal
            isSuccessShow={show}
            setIsSuccessShow={setShow}
            onClose={onCloseRoll}
          />
          : null}
      </div>
    </>
  )
}
export default ArchiveModal